import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { IPatientArchivesQuery } from 'src/app/shared/interfaces';

export interface IFileDownloaderMeta {
  name?: string;
}

export interface IFileDownloaderTick {
  query: IPatientArchivesQuery;
  meta: IFileDownloaderMeta;
}

@Injectable({
  providedIn: 'root',
})
export class FileDownloaderService {
  private _dowloadTick = new Subject<IFileDownloaderTick>();
  public downloadTick$ = this._dowloadTick.asObservable();

  public downloadTick(data: IFileDownloaderTick): void {
    this._dowloadTick.next(data);
  }
}
